import * as React from "react";
import classNames from "classnames";

interface InactiveAssigneeRecord {
  removed?: boolean;
  projectMembershipActive?: boolean;
}

interface InactiveAssigneeTextProps extends InactiveAssigneeRecord {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const isInactiveAssignee = (record: InactiveAssigneeRecord): boolean =>
  Boolean(record.removed || !record.projectMembershipActive);

export const InactiveAssigneeText: React.FC<InactiveAssigneeTextProps> = ({
  removed,
  projectMembershipActive,
  className,
  style,
  children,
}) => (
  <span
    className={classNames(className, { "color-red": isInactiveAssignee({ removed, projectMembershipActive }) })}
    style={style}
  >
    {children}
  </span>
);
